export default "/_next/static/images/7ee5288ef48f8ce67d641925ae9dae14.jpg";